import {pageHeader, PageHeader} from "./page-header/CompanyInformationPageHeaderComponent";
import {companyStatistics, CompanyStatistics} from "./stats/CompanyStatisticsComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.component`;

    return angular.module(moduleName, [])
                  .component(PageHeader, pageHeader())
                  .component(CompanyStatistics, companyStatistics())
                  .name;
}
